import React from "react";
import { useTheme } from "theme";

const Copyright: React.FC = () => {
    const theme = useTheme();

    return (
        <>
            © {new Date().getFullYear()} {theme.brand.companyName}
        </>
    );
};

export default Copyright;
